import { APPLE_SOCIAL, FACEBOOK_SOCIAL, LINE_SOCIAL } from '../constant/social'
import { EMAIL_PROVIDER } from '../constant/provider'

import _Vue from 'vue' // <-- notice the changed import

function ConstantPlugin(Vue: typeof _Vue): void {
  Vue.prototype.$constant = {
    APPLE_SOCIAL,
    FACEBOOK_SOCIAL,
    LINE_SOCIAL,
    EMAIL: EMAIL_PROVIDER
  }
}

export default ConstantPlugin
